import React, { useState } from "react";
import { View, StyleSheet, Text, TextInput } from "react-native";
import Error from "@assets/svg/Error";
import t from "@constants/localization";
import SkipButton from "./skipButton";
import SaveButton from "./saveButton";

const PATH = "screens/CLProfile/components/inputField";

export default function DropdownList(props) {
  const {
    index,
    data,
    placeholder = "",
    onSubmit = () => {},
    value = "",
    onSkip = () => {},
  } = props;
  const [text, setText] = useState(value);

  return (
    <View
      style={{
        marginTop: 40,
        flex: 1,
      }}
    >
      <View style={{ flex: 1 }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            ...styles.searchInput,
          }}
        >
          <Text style={{ fontSize: 16, color: "rgba(0, 0, 0, 0.5)" }}>+91</Text>
          <View
            style={{
              borderWidth: 1,
              height: 20,
              margin: 5,
              borderColor: "rgba(0, 0, 0, 0.5)",
            }}
          />
          <TextInput
            placeholderTextColor="rgba(0, 0, 0, 0.36)"
            placeholder={data.placeholder}
            style={{
              width: "100%",
              fontSize: 16,
              paddingLeft: 10,
            }}
            value={text}
            onChangeText={setText}
            keyboardType={data.keyboardType}
            maxLength={data.type === "phone" ? 10 : null}
          />
        </View>
        {props.alternatePhNoError ? (
          <View style={styles.errorView}>
            <Error />
            <Text style={styles.errorText}>
              {t(`${PATH}/thiIsYouPrimaryNumber`)}
            </Text>
          </View>
        ) : null}
      </View>
      <View
        style={{
          flexDirection: "row",
        }}
      >
        {/* <SkipButton
          handlePress={() => onSkip(index, { [data.name]: null }, data.name)}
          btnField={data.name}
          isActive={data.is_skipable && !value}
        /> */}
        <SaveButton
          handlePress={() => onSubmit(index, { [data.name]: text }, data.name)}
          isActive={text && text !== "" && text.length === 10}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  searchInput: {
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "rgba(0, 0, 0, 0.1)",
    fontFamily: "NotoSansDevanagari-Regular",
    padding: 10,
    paddingHorizontal: 16,
  },
  errorView: {
    marginTop: 10,
    flexDirection: "row",
  },
  errorText: {
    color: "red",
  },
});
